module.exports = {
    "c515f464-6a96-45b3-aabb-92e62a268c3f": {
        name: 'Sandbox Organization',
        clientLead: ['joshuamacfawn']
    },
    "5484a17b-b1d9-443e-b441-0581c5e98187": {
        name: 'National Consortium of Health Science Educators',
        clientLead: ['jamieldunn', 'jkriggs']
    },
    "60a8b613-c42e-4590-b9f8-3865a3f0eb1c": {
        name: 'Washington DECA',
        clientLead: ['danielletuason', 'jkriggs']
    },
    "88aff8b9-c7a6-467c-877d-754ed7219601": {
        name: 'Michigan FFA',
        clientLead: ['christuason', 'jkriggs']
    }
};
